import { render, staticRenderFns } from "./FileGroupPreview.vue?vue&type=template&id=de601f4c&scoped=true&"
import script from "./FileGroupPreview.vue?vue&type=script&lang=ts&"
export * from "./FileGroupPreview.vue?vue&type=script&lang=ts&"
import style0 from "./FileGroupPreview.vue?vue&type=style&index=0&id=de601f4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de601f4c",
  null
  
)

export default component.exports